import { c as _c } from "react/compiler-runtime";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@achra/ui/empty';
import { cn } from '@achra/ui/lib/utils';
import { type LucideIcon, ServerCrash } from 'lucide-react';
interface GenericErrorStateProps {
  icon?: LucideIcon;
  title?: string;
  description?: string;
  showBorder?: boolean;
  className?: string;
}
function GenericErrorState(t0) {
  const $ = _c(16);
  const {
    icon: Icon,
    title,
    description,
    showBorder: t1,
    className
  } = t0;
  const showBorder = t1 === undefined ? true : t1;
  const t2 = showBorder && "border border-solid";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("bg-background mx-auto w-full max-w-sm md:p-6", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== Icon) {
    t4 = <EmptyMedia variant="icon">{Icon ? <Icon /> : <ServerCrash />}</EmptyMedia>;
    $[3] = Icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = title ?? "Something went wrong";
  let t6;
  if ($[5] !== t5) {
    t6 = <EmptyTitle>{t5}</EmptyTitle>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = description ?? "We ran into an unexpected error while loading this section. Please try again later.";
  let t8;
  if ($[7] !== t7) {
    t8 = <EmptyDescription>{t7}</EmptyDescription>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t8) {
    t9 = <EmptyHeader>{t4}{t6}{t8}</EmptyHeader>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t3 || $[14] !== t9) {
    t10 = <Empty className={t3}>{t9}</Empty>;
    $[13] = t3;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}
export { GenericErrorState };